import { render, staticRenderFns } from "./PriorityTypeDelete.vue?vue&type=template&id=32cc410f&"
import script from "./PriorityTypeDelete.vue?vue&type=script&lang=js&"
export * from "./PriorityTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports